import { render, staticRenderFns } from "./ProjectAsset.vue?vue&type=template&id=7a48738b"
import script from "./ProjectAsset.vue?vue&type=script&lang=js"
export * from "./ProjectAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports